import { render, staticRenderFns } from "./EndPromotionalCampaignButton.vue?vue&type=template&id=4aa395f8"
import script from "./EndPromotionalCampaignButton.vue?vue&type=script&setup=true&lang=js"
export * from "./EndPromotionalCampaignButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports